export default {
  newlyCreatedInvoice: {}
};
